import { render } from "./Introduction2.vue?vue&type=template&id=3d5bde26&scoped=true"
import script from "./Introduction2.vue?vue&type=script&lang=js"
export * from "./Introduction2.vue?vue&type=script&lang=js"

import "./Introduction2.vue?vue&type=style&index=0&id=3d5bde26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d5bde26"

export default script